import styled from 'styled-components';

export const BannerButton = styled.button`
z-index:99999999;
border:3px solid #c4312e;
font-size:calc(.7em + 2vw);
background:none;
border-radius:20px;
color:white;
padding: calc(0.3em + 0.1vw) calc(1.3em + 0.1vw);
position:absolute;
top:60vh;
right:0;
left:0;
margin-left:auto;
margin-right:auto;
cursor:pointer;

@media only screen and(max-width:320px){
    right:6vw;
}
`
